<template>
  <v-container>
    <v-card width="300" class="mx-auto" @click="edit">
      <v-list-item>
        <v-list-item-content class="pa-0">
          <v-list-item-title class="title pa-0">{{ covenant.patientName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="pa-0">
        <v-container no-gutters class="pa-0 px-3">
          <v-row no-gutters align="center" justify="space-around">
            <v-col no-gutters md="9">
              <div class="subtitle-2">{{ covenant.covenantName }}</div>
              <!-- <div class="subtitle-2 pb-2">{{ covenant.planName }}</div> -->
              <div>
                {{ covenant.cardNumber }}
                <v-icon class="pl-3">mdi-account-card-details</v-icon>
              </div>
              <div v-if="!isFecomercio">{{ covenant.validate | date }}</div>
            </v-col>
            <v-col no-gutters md="2">
              <v-list-item-avatar size="50">
                <v-img :src="covenant.patientAvatar"></v-img>
              </v-list-item-avatar>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn text icon @click.stop="confirmRemove = true" color="accent">
          <v-icon :loading="removeLoading">mdi-close</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn text icon @click.stop="edit" color="accent">
          <v-icon>mdi-square-edit-outline</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <confirmation-dialog v-model="confirmRemove" @confirm="remove">
      <div>
        Deseja remover o convênio
        <b>{{ covenant.covenantName }}</b>
      </div>
    </confirmation-dialog>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import ConfirmationDialog from '@/components/general/ConfirmationDialog';

const Hashids = require('hashids');

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    Hashids: null,
    covenant: null,
    removeLoading: false,
    confirmRemove: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    isFecomercio() {
      return this.$store.getters['poweredBy/th'] === 'lnMQZ9bbUq';
    },
  },
  created() {
    this.Hashids = new Hashids.default(process.env.VUE_APP_HASHID_SALT, Number(process.env.VUE_APP_HASHID_PAD));
    this.covenant = this.value;
  },
  methods: {
    edit() {
      this.$router.push({
        name: 'covenants-cadastre',
        params: {
          id: this.Hashids.encode(this.covenant.id),
          covenant: this.covenant,
        },
      });
    },
    remove() {
      this.removeLoading = true;
      this.$store
        .dispatch('patientCovenants/remove', this.covenant.id)
        .then(() => {
          bus.$emit('message', {
            message: 'Convênio removido com sucesso!',
            type: 'success',
          });
          this.$emit('removed', this.covenant.id);
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.removeLoading = true;
        });
    },
  },
  components: {
    ConfirmationDialog,
  },
};
</script>
